// extracted by mini-css-extract-plugin
export default {"moveBtn":"AdminMobileRegisterBtn_moveBtn__RX4Dm"};